import { useState } from 'react';
import { CartesianGrid, Cell, ResponsiveContainer, Scatter, ScatterChart, Tooltip, XAxis, YAxis } from 'recharts';
import CustomTooltip from '../ConnectedDataChart/Tooltip/CustomTooltip';

import { colors } from '../../../../utils/palette';
import { useTheme } from '@mui/material';

export interface InsightsScatterPlotChartData {
  x: number;
  y: number;
  z: string;
  resolution_id: string;
}

export interface InsightsScatterPlotChartProps {
  data: any;
  type: 'insightScatterChart';
  cluster: number;
  history?: (p: string) => void;
}
const CustomizedAxisTick = ({ x, y, payload }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} dx={10} textAnchor="end" fill="rgb(102, 102, 102)" fontSize={10}>
        {payload.value}
      </text>
    </g>
  );
};

const InsightsScatterPlot: React.FC<InsightsScatterPlotChartProps> = ({ data, cluster, history }) => {
  const domain: Record<number, number[]> = {
    1: [0, 225],
    2: [226, 450],
    3: [451, 550],
    4: [551, 775],
    5: [776, 1000],
    0: [0, 1000],
  };
  const theme = useTheme();
  const [ko, setKo] = useState<boolean>(false);
  return (
    <ResponsiveContainer width="100%" height={400}>
      <ScatterChart
        margin={{
          top: parseInt(theme.spacing(7)),
          right: parseInt(theme.spacing(2)),
          bottom: parseInt(theme.spacing(2)),
          left: parseInt(theme.spacing(2)),
        }}
      >
        <CartesianGrid stroke={colors.pageBackground} />
        <Tooltip
          cursor={{ fill: 'transparent' }}
          wrapperStyle={{
            backgroundColor: colors.textSecondary,
            width: 150,
            borderRadius: 4,
            textAlign: 'center',
            color: colors.white,
            marginTop: theme.spacing(-3),
          }}
          label="score"
          key="score"
          content={<CustomTooltip custom_label="SCORE" isKo={ko} />}
        />
        <XAxis type="number" dataKey="x" name="score" tick={<CustomizedAxisTick />} stroke={colors.pageBackground} domain={domain[cluster]} />
        <YAxis type="number" dataKey="y" name="weight" hide domain={[-5, 5]} />
        <Scatter data={data}>
          {data?.map((d: InsightsScatterPlotChartData, n: number) => {
            return (
              <Cell
                onMouseOver={() => {
                  setKo(d.z === 'ko');
                }}
                onClick={() => history && history(d.resolution_id)}
                name="score"
                key={n}
                style={{ cursor: 'pointer' }}
                fill={d.z === 'ok' ? colors.success.main : colors.error.main}
              />
            );
          })}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default InsightsScatterPlot;
